import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgForm, FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ContratosService } from '../../services/contratos.service';
import { AuthService } from '../../services/auth.service';
import { MatDialogModule, MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { LocalizationService } from '../../services/localization.service';
import { ContratoModel } from '../../models/ContratoModel';
import * as moment from 'moment';

@Component({
  selector: 'app-contratos-edit',
  templateUrl: './contratos-edit.component.html',
  styleUrls: ['./contratos-edit.component.scss']
})
export class ContratosEditComponent implements OnInit {

  contrato: ContratoModel;
  localization: LocalizationService;
  contratoForm: FormGroup;
  title: string = "Crear";
  isNewElement: boolean;

  id: number;
  isModal: boolean;
  errorMessage: any;

  tipoContratoList: any;
  tarifaList: any;
  options: any = {
    format: 'DD/MM/YYYY'
  };

  constructor(private _fb: FormBuilder, private _avRoute: ActivatedRoute, localization: LocalizationService,
    private _ContratosService: ContratosService, private _authService: AuthService, private _router: Router,
    public dialogRef: MatDialogRef<ContratosEditComponent>,
    private _location: Location) {

    this.contrato = new ContratoModel();

    this.localization = localization;

    if (this._avRoute.snapshot.params["id"]) {
      this.id = this._avRoute.snapshot.params["id"];
    }

    this.contratoForm = this._fb.group({
      id: 0,
      //tipo: [''],
      tipoContratoId: ['', Validators.required],
      nombre: ['', Validators.required],
      fechaEntrada: ['', Validators.required],
      fechaExpiracion: [null],
      //tarifa: [''],
      tarifaId: ['', Validators.required],
      activo: [true],
      createdBy: [''],
      updatedBy: [''],
      updatedDate: [''],
      createdDate: [new Date],
      //createdByName: [''],
      //updatedByName: ['']
    });
  }

  ngOnInit() {
    if (this.id > 0) {
      this.isNewElement = false;
      this.title = 'Editar';
      // this._ContratosService.getContrato(this.id)
      //   .subscribe(resp => {
      //     this.contratoForm.setValue(resp);
      //     this.EsPrivada();
      //   }
      //     , error => {
      //       this.errorMessage = error;
      //       console.log(error);
      //     });
      this._ContratosService.getContrato(this.id)
        .subscribe((resp: ContratoModel) => {
          if (resp == null) {
            this._router.navigate(['/contratos']);
          }
          this.contrato = resp;
          this.contratoForm.setValue(resp);
          //this.EsPrivada();
        }, error => {
          this.errorMessage = error;
          console.log(error);
        });
    } else {
      this.isNewElement = true;
    }

    this._ContratosService.getTipoContratos().subscribe(data => this.tipoContratoList = data);
    this._ContratosService.getTarifas().subscribe(data => this.tarifaList = data);


  }

  public moment(data) {
    if (data === '' || data == null) {
      return null;
    }
    return moment.utc(data).local().format('DD/MM/YYYY');
  }

  closeDialog() {
    this.dialogRef.close();
  }

  cancel() {
    if (!this.isModal) {
      this._location.back();
    } else {
      this.closeDialog();
    }
  }

  save() {
    console.log(this.contratoForm.valid)
    if (!this.contratoForm.valid) {
      return;
    }

    if (this.isNewElement) {
      this._ContratosService.createContrato(this.contratoForm.value)
        .subscribe((data) => {
          if (!this.isModal)
            this._location.back();
          else
            this.closeDialog();
        }, error => this.errorMessage = error)
    }
    else {
      this._ContratosService.updateContrato(this.id, this.contratoForm.value)
        .subscribe((data) => {
          if (!this.isModal)
            this._location.back();
          else
            this.closeDialog();
        }, error => this.errorMessage = error)
    }
  }

  // EsPrivada() {
  //   if (this.contratoForm.get('tipoContratoId').value == "PV") {
  //     this.contratoForm.get('tarifaId').disable()
  //   }
  //   else {
  //     this.contratoForm.get('tarifaId').enable()
  //   }
  // }

  get nombre() { return this.contratoForm.get('nombre'); }
  get nombre_PT() { return this.contratoForm.get('nombre_PT'); }
  get tipoContratoId() { return this.contratoForm.get('tipoContratoId'); }
  get fechaEntrada() { return this.contratoForm.get('fechaEntrada'); }
  get tarifaId() { return this.contratoForm.get('tarifaId'); }
}
